import { createSlice } from '@reduxjs/toolkit'

// general imports
import {
  ApiRequestDataType,
  ApiRequestStatus,
  StoredErrorResponseType,
} from '../../../types/api/api.types'
import { RegistrationDataType } from '../../../types/auth.types'
import { createUserAccountThunk, verifyAndCompleteThunk } from '../thunks/auth.thunk'

export type RegistrationState = {
  // eslint-disable-next-line
  requestResponse: ApiRequestDataType<any>
  user: RegistrationDataType | null
}

export const initialState: RegistrationState = {
  requestResponse: {
    status: ApiRequestStatus.IDLE,
    data: null,
  },
  user: {},
}

const registrationSlice = createSlice({
  name: 'registrationSlice',
  initialState: initialState,
  reducers: {
    resetRegistrationState: (state) => {
      ;(state.requestResponse.status = ApiRequestStatus.IDLE), (state.requestResponse.data = null)
    },
    setUser: (state, action) => {
      state.user = { ...state.user, ...action.payload }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createUserAccountThunk.pending, (state) => {
        console.log('🔵 [REGISTER SLICE] createUserAccountThunk pending')
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      .addCase(createUserAccountThunk.fulfilled, (state, action) => {
        console.log('🟢 [REGISTER SLICE] createUserAccountThunk fulfilled:', action.payload)
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        state.requestResponse.data = action.payload.message || action.payload.description
      })
      .addCase(createUserAccountThunk.rejected, (state, action) => {
        console.error('🔴 [REGISTER SLICE] createUserAccountThunk rejected:', action.payload)
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
      // Two-Phase Registration: Verify and Complete
      .addCase(verifyAndCompleteThunk.pending, (state) => {
        console.log('🔵 [REGISTER SLICE] verifyAndCompleteThunk pending')
        state.requestResponse.status = ApiRequestStatus.PENDING
        state.requestResponse.data = null
        state.requestResponse.error = {} as StoredErrorResponseType
      })
      .addCase(verifyAndCompleteThunk.fulfilled, (state, action) => {
        console.log('🟢 [REGISTER SLICE] verifyAndCompleteThunk fulfilled:', action.payload)
        state.requestResponse.status = ApiRequestStatus.FULFILLED
        state.requestResponse.data = action.payload.message
        // Store user data from response
        if (action.payload.user) {
          state.user = { ...state.user, ...action.payload.user }
        }
      })
      .addCase(verifyAndCompleteThunk.rejected, (state, action) => {
        console.error('🔴 [REGISTER SLICE] verifyAndCompleteThunk rejected:', action.payload)
        state.requestResponse.status = ApiRequestStatus.REJECTED
        state.requestResponse.error = action.payload as StoredErrorResponseType
      })
  },
})

export const { resetRegistrationState, setUser } = registrationSlice.actions
export default registrationSlice.reducer
